import React from 'react';
import styled from 'styled-components';
import { SourceInfo, PatternFormat } from 'react-number-format';

export interface NumberFormatValues {
  floatValue: number | undefined;
  formattedValue: string;
  value: string;
}

export interface InputNumberProps {
  name?: string;
  placeholder?: string;
  format?: string;
  displayType?: 'input' | 'text';
  type?: 'text' | 'tel' | 'password';
  className?: string;
  testId?: string;
  disabled?: boolean;
  onInputChange?: (
    value: string,
    values?: NumberFormatValues,
    sourceInfo?: SourceInfo,
  ) => void;
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
}

export const InputNumber = ({
  name,
  placeholder,
  format,
  displayType,
  type,
  className,
  testId,
  disabled,
  onInputChange,
  onKeyDown,
  ...rest
}: InputNumberProps) => {
  return (
    <InputNumberWrapper className={className}>
      <PatternFormat
        name={name}
        placeholder={placeholder}
        format={format}
        disabled={disabled}
        displayType={displayType}
        type={type}
        data-test-id={testId}
        onKeyDown={onKeyDown}
        onValueChange={(values: NumberFormatValues, sourceInfo: SourceInfo) => {
          if (onInputChange) {
            onInputChange(values.value, values, sourceInfo);
          }
        }}
        {...rest}
      />
    </InputNumberWrapper>
  );
};

const InputNumberWrapper = styled.div`
  display: flex;
  flex-direction: column;
  border: none;
  margin: 8px 0;
  padding: 0;
  min-width: auto;
  font-family: 'Open Sans', sans-serif;
`;

const defaultProps: Partial<InputNumberProps> = {
  disabled: false,
  displayType: 'input',
  type: 'text',
};
InputNumber.defaultProps = defaultProps;
InputNumber.displayName = 'InputNumber';
